import React, { useState, useEffect } from "react";

const TTSSetting = (props) => {

    const [selectedServer, setSelectedServer] = useState(props.value);

    const [groupSelection, setGroupSelection] = useState(false);

    const [groupList, setGroupList] = useState([]);

    useEffect(() => {
        console.log("GROUPS", props.server, props.groups);
        if(props.groups){
            props.groups.forEach(g => {
                console.log("MATCH CHECK", g, props.server, g.name === props.server.value);
                if(g.name === props.server.value){
                    console.log("GROUP LIST SET", g.groups);
                    setGroupList(g.groups);
                    return;
                }
            });
        }
    }, []);

    const changeServer = (val) => {
        console.log("SERVER CHANGED?", val);
        setSelectedServer(val);

        let found = [];
        props.groups.forEach(g => {
            if(g.name === val){
                found = g;
                return;
            }
        });

        console.log("FOUND SERVER IN LIST", found);

        setGroupList(found.groups);
    }

    const changeGroup = (val) => {
        props.changeGroup(props.index, selectedServer, val);
        setGroupSelection(false);
    }

    // const toggle = (server) => {
    //     console.log("TOGGLE TTS", server, selectedServer, server !== selectedServer);
    //     props.toggle();
    //     if(server !== selectedServer){
    //         console.log("CHANGE SERVER");
    //         changeServer(server);
    //     }
    // }

    const clickSlider = (val) => {
        if(props.group !== val){
            changeServer(val);
        }
        setGroupSelection(true);
    }

    const closeActive = () => {
        props.closeActive();
        console.log("CLOSE ACTIVE", props.group);
    }

    return (
        <div className="tts-setting">
            <div className="tts-setting-location">{props.location}</div>
            <div className="tts-setting-values">
                {
                    groupSelection
                    ? <div className="tts-inner">
                        <div className="close-active" onClick={() => setGroupSelection(false)}>X</div>
                        <div style={{marginBottom: "4px"}}>
                            <select value={selectedServer} onChange={evt => changeServer(evt.target.value)}>
                            {
                                props.groups.map((s, index) => {
                                    return (
                                        <option key={"server_" + index} value={s.name}>{s.name}</option>
                                    )
                                })
                            }
                            </select>
                        </div>
                        <div>
                            <select value={props.group} onChange={evt => changeGroup(evt.target.value)}>
                                <option value={-1}>Select a Group</option>
                            {
                                groupList && groupList.map((g, index) => {
                                    return (
                                        <option key={"group_" + index} value={g.name}>{g.name}</option>
                                    )
                                })
                            }
                            </select>
                        </div>
                    </div>
                    : <div>
                        <div className="tts-slider">
                            <div 
                                className={"tts-aws" + (props.value === "AWS" ? " selected" : " not-selected")}
                                onClick={() => clickSlider("AWS")}
                            >
                                AWS
                                {
                                    props.group && props.value === "AWS"
                                    ? <div className="group-hover">{props.group}</div>
                                    : null
                                }
                            </div>
                            <div 
                                className={"tts-onprem" + (props.value === "Newark_HQ" ? " selected" : " not-selected")}
                                onClick={() => clickSlider("Newark_HQ")}
                            >
                                Newark HQ
                                {
                                    props.group && props.value === "Newark_HQ"
                                    ? <div className="group-hover">{props.group}</div>
                                    : null
                                }
                            </div>
                        </div>
                    </div>
                }
            </div>
        </div>
    )
}

export default TTSSetting;